import Button from '@components/Button';
import LocationIcon from '@components/Map/LocationIcon';
import styled from '@emotion/styled';
import { useMap } from '@vis.gl/react-google-maps';

interface Props {
    center: LatLng;
}

function LocationButton({ center }:Props) {
    const map = useMap('google-map');
    return (
        <Base size='sm'
            onClick={() => {
                map?.setCenter(center);
            }} >
            <LocationIcon/>
            내 위치 확인
        </Base>
    );
}

const Base = styled(Button)`
    border-radius: 15px;
    bottom: 12px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    column-gap: 2px;
    display: flex;
    height: 36px !important;
    padding: 6px 12px !important;
    position: absolute !important;
    z-index: 2;
`;

export default LocationButton;
